import { render, staticRenderFns } from "./TrialInformation.vue?vue&type=template&id=e68c24a2&scoped=true"
import script from "./TrialInformation.vue?vue&type=script&lang=js"
export * from "./TrialInformation.vue?vue&type=script&lang=js"
import style0 from "./TrialInformation.vue?vue&type=style&index=0&id=e68c24a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c24a2",
  null
  
)

export default component.exports